import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const userToken = localStorage.getItem('token');
  const isVerified = JSON.parse(localStorage.getItem('isVerified'));

  return userToken && isVerified ? <Outlet /> : <Navigate to='/' />;
};

export default ProtectedRoute;
